import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { User, Mail, Lock, Phone, ArrowRight } from "lucide-react";
import ToastHelper from "@/utils/toastHelper";
import { Switch } from "@/components/ui/switch";

export default function Register() {
  const nav = useNavigate();
  const [f, setF] = useState({
    first: "",
    last: "",
    email: "",
    phone: "",
    password: "",
  });
  const submit = (e) => {
    e.preventDefault();
    ToastHelper.success("Account created! A verification email has been sent.");
    setTimeout(() => nav("/student/dashboard"), 600);
  };
  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="wc-card p-8">
        <h1 className="text-2xl font-display font-extrabold text-[#0A2540]">
          Create your student account
        </h1>
        <p className="text-sm text-slate-500 mt-1 mb-6">
          Save your details, enrol online and track your certificate.
        </p>
        <form
          onSubmit={submit}
          className="space-y-4"
          data-testid="register-form"
        >
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="wc-label">First name</label>
              <input
                required
                className="wc-input"
                value={f.first}
                onChange={(e) => setF({ ...f, first: e.target.value })}
                data-testid="reg-first"
              />
            </div>
            <div>
              <label className="wc-label">Last name</label>
              <input
                required
                className="wc-input"
                value={f.last}
                onChange={(e) => setF({ ...f, last: e.target.value })}
                data-testid="reg-last"
              />
            </div>
          </div>
          <div>
            <label className="wc-label">Email</label>
            <div className="relative">
              <Mail className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
              <input
                required
                type="email"
                className="wc-input pl-9"
                value={f.email}
                onChange={(e) => setF({ ...f, email: e.target.value })}
                data-testid="reg-email"
              />
            </div>
          </div>
          <div>
            <label className="wc-label">Phone</label>
            <div className="relative">
              <Phone className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
              <input
                required
                className="wc-input pl-9"
                value={f.phone}
                onChange={(e) => setF({ ...f, phone: e.target.value })}
                data-testid="reg-phone"
              />
            </div>
          </div>
          <div>
            <label className="wc-label">Password</label>
            <div className="relative">
              <Lock className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
              <input
                required
                type="password"
                minLength={6}
                className="wc-input pl-9"
                value={f.password}
                onChange={(e) => setF({ ...f, password: e.target.value })}
                data-testid="reg-password"
              />
            </div>
          </div>
          <label className="flex items-start gap-2 text-xs text-slate-600">
            <Switch required />I agree to the
            terms of service and privacy policy.
          </label>
          <button
            type="submit"
            className="wc-btn-primary w-full justify-center"
            data-testid="reg-submit"
          >
            Create account <ArrowRight className="w-4 h-4" />
          </button>
        </form>
        <div className="mt-5 text-center text-sm text-slate-600">
          Already have an account?{" "}
          <Link
            to="/login"
            className="font-semibold text-[#0A2540] hover:text-orange-600"
          >
            Sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
